<template>
  <div class="d-flex" v-if="Object.keys(tasks).length > 0">
    <div class="flex flex--wrap">
      <div class="col-6 bg-white d-flex">
        <div class="col-4 mt-4 operators">
          <operators :operators="tasks.operators" />
        </div>
        <div class="col-8 mt-4">
          <tasks :tasks="tasks.tasks" :state="tasksStatus" />
        </div>
      </div>
      <div class="col ml-5 bg-white">
        <div class="mt-4 mb-2">
          <campaign :campaign_id="campaignId" :campaign="campaign" :tasks="tasks" />
        </div>
      </div>
      <div class="w-100 mt-4 bg-white">
        <div class="mt-4 mb-3">
          <progress-tasks :tasks="tasks.tasks" />
        </div>
      </div>
      <div class="w-100 mt-4 bg-white">
        <div class="mt-4">
          <rooms :tasks="tasks" />
        </div>
      </div>
      <div class="w-100 mt-4 bg-white">
        <div class="mt-4 mb-3">
          <all-operators :operators="tasks.operators" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Operators from './monitoring-operators';
  import Tasks from './monitoring-tasks';
  import ProgressTasks from './monitoring-progress-tasks';
  import AllOperators from './monitoring-all-operators';
  import Rooms from './monitoring-rooms';
  import Campaign from './monitoring-campaign';
  import { MonitoringService } from '@autocaller_v2/services/MonitoringService';
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  export default {
    components: {
      Operators,
      Tasks,
      Campaign,
      ProgressTasks,
      AllOperators,
      Rooms
    },
    props: {
      campaign: {
        type: Object,
        default: () => {}
      },
      single: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tasks: [],
        interval_task: null,
        interval_campaign: null,
        delay_task: 1000,
        delay_campaign: 20000
      };
    },
    created() {
      this.getMonitoringData();
      this.interval_task = setInterval(() => {
        this.getMonitoringData();
      }, this.delay_task);
      this.interval_campaign = setInterval(() => {
        this.getCampaignData();
      }, this.delay_campaign);
    },
    computed: {
      campaignId() {
        if (this.single) {
          return this.campaign.id;
        } else {
          return this.$route.params.id;
        }
      },
      tasksStatus() {
        return [
          {
            state: 'pending',
            name: this.$t('autocaller_v2.monitoring.tasks.pending.state')
          },
          {
            state: 'dialing',
            name: this.$t('autocaller_v2.monitoring.tasks.dialing.state')
          },
          {
            state: 'connected',
            name: this.$t('autocaller_v2.monitoring.tasks.connected.state')
          },
          {
            state: 'processing',
            name: this.$t('autocaller_v2.monitoring.tasks.processing.state')
          },
          {
            state: 'active',
            name: this.$t('autocaller_v2.monitoring.tasks.active.state')
          },
          {
            state: 'checking',
            name: this.$t('autocaller_v2.monitoring.tasks.checking.state')
          }
        ];
      }
    },
    methods: {
      getMonitoringData() {
        MonitoringService.getList(this.campaignId).then((data) => {
          this.tasks = data || [];
        });
      },
      getCampaignData() {
        CampaignsService.getItem(this.campaignId).then((data) => {
          this.campaign = data || {};
        });
      }
    },
    destroyed() {
      clearInterval(this.interval_task);
      clearInterval(this.interval_campaign);
    }
  };
</script>

<style lang="scss">
  .operators {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      right: 40px;
      top: 0;
      display: block;
      width: 1px;
      height: 95%;
      background: $border-pending;
    }
  }
  .text-decoration-underline {
    text-decoration: underline;
  }
</style>
